import axios from '../..';

export const fetchAllUnits = () => axios.get('api/admin/assessments/all-units');

export const fetchAllAssessmentAndUnitsByQualId = qualificationId =>
  axios.get(`api/admin/assessments-with-units?qu_id=${qualificationId}`);
